import { LoadableLazy } from '@confluence/loadable';

export const InvisibleLoadingContainer = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-readingAidsPopup" */ '../src/ReadingAidsPopup.tsx'))
			.InvisibleLoadingContainer,
});
